import { UnitCreateMultiplePage } from '@apps-common/apps/portal/pages/units/pages/create-multiple/Index'

export const UnitCreateMultiple = () => <UnitCreateMultiplePage />
